import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CheckRender from "../../../components/Common/CheckRender";
import { columnasProcedimientosDetalle } from "../utils/HospitalizacionConstant";
import { DeleteOutlined } from "@ant-design/icons";

const RenderCoberturasHojaQX = ({ coberturasMedicos, onEliminarCobertura, coberturasEnviadas, coberturasDuplicadasIds, coberturasEnviadasFlag = false, tipoReclamante }) => {
  const columns = [
    ...columnasProcedimientosDetalle(tipoReclamante),
    {
      title: "Acciones",
      key: "acciones",
      width: "10%",
      render: (_, record) => {
        if (coberturasEnviadasFlag) {
          return null;
        }

        const estaEnviada = coberturasEnviadas?.has(record.id);
        const esDuplicada = coberturasDuplicadasIds?.has(record.id);
        
        if (estaEnviada && !esDuplicada) {
          return null;
        }

        const buttonStyles = {
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "#ff4d4f",
          fontSize: "16px",
          padding: "4px 8px",
        };

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              onClick={() => onEliminarCobertura(record.key)}
              style={buttonStyles}
              title="Eliminar cobertura"
            >
              <DeleteOutlined />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <Section>
      <CheckRender allowed={coberturasMedicos.length > 0}>
        <CustomTable
          columns={columns}
          dataSource={coberturasMedicos}
          pageSize={100}
          containerWidth="100%"
          width="100%"
        />
      </CheckRender>
      <CheckRender allowed={coberturasMedicos.length === 0}>
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "#666",
            fontSize: "16px",
          }}
        >
          No hay coberturas disponibles para este paciente
        </div>
      </CheckRender>
    </Section>
  );
};

export default RenderCoberturasHojaQX;

